import { useEffect, useRef, useState } from 'react';
import { HeroSellingPoint, IImage } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import styles from './HeroSection.module.scss';
import Img from '../../../components/Img';

export type THeroItem = {
  id: number;
  text: string;
  images?: IImage[];
};

export type TImageType = 'large' | 'small';

export type ItemView = 'left' | 'right' | 'primary' | 'secondary';

interface IImagesItemProps {
  item: HeroSellingPoint;
  type: 'textOnly' | TImageType;
  view: ItemView;
}

const ImagesItem = ({ item, type, view }: IImagesItemProps) => {
  const firstImage = item?.media?.[0] || null;
  const [activeImage, setActiveImage] = useState<IImage | null>(firstImage);
  const intervalRef = useRef<NodeJS.Timer | null>(null);
  const activeItemIndexRef = useRef<number>(0);

  const handleImageChange = () => {
    let newIndex = activeItemIndexRef.current + 1;
    const maxIndex = (item.media?.length || 0) - 1;

    if (newIndex > maxIndex) {
      newIndex = 0;
    }

    setActiveImage(item.media?.[newIndex] as IImage);
    activeItemIndexRef.current = newIndex;
  };

  const handleStopImagesChange = () => {
    setActiveImage(item.media?.[0] || null);
    activeItemIndexRef.current = 0;

    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const handleStartImagesChange = () => {
    if (!item.media?.length) return;
    setActiveImage(item.media[1]);
    activeItemIndexRef.current = 1;
    const intervalId = setInterval(handleImageChange, 1000);
    intervalRef.current = intervalId;
  };

  useEffect(() => () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  }, []);

  return (
    <div
      className={classNames(styles.imageItem, styles[type], styles[view])}
      onMouseEnter={handleStartImagesChange}
      onMouseLeave={handleStopImagesChange}
    >
      <p className={styles.text}>{item.text}</p>
      {!!activeImage && (
      <Img
        src={activeImage.url}
        width={activeImage.width}
        height={activeImage.height}
        alt={activeImage.alternativeText || 'image'}
        className={styles.right_bottom_inverted_radius}
      />
      )}
    </div>
  );
};

export default ImagesItem;
